export const formatEmail = (email: string) => {
  // if first character is a 0, then the login method is 'phone', remove the + sign
  if (email?.charAt(0) === '+') {
    return email.substring(1);
  }
  return email;
};
